export default __webpack_public_path__ + "static/mr-fuel-ee3549d1a33f23586ab47a6d4504594d.png";